module.exports = __webpack_public_path__ + "static/media/icon_unmonitored.85de50fc.svg";